import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { listTags, saveTag, deleteTag } from '../services/api';

const TagsPage = () => {
  const [tags, setTags] = useState([]);
  const [editing, setEditing] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    setTags(await listTags());
  };

  const handleSave = async () => {
    if (!editing?.nome) return;
    await saveTag(editing);
    setEditing(null);
    load();
  };

  return (
    <Box p={2} sx={{ maxWidth: 760, mx: 'auto' }}>
      <IconButton onClick={() => navigate(-1)} sx={{ mb: 1 }} aria-label="Voltar">
        <ArrowBack />
      </IconButton>
      <Typography variant="h5" mb={2}>
        Tags
      </Typography>
      <Box mb={2} display="flex" alignItems="center">
        <TextField
          label="Nome"
          value={editing?.nome || ''}
          onChange={(e) => setEditing({ ...editing, nome: e.target.value })}
        />
        <Button
          sx={{ ml: 1 }}
          variant="contained"
          onClick={handleSave}
        >
          {editing?.id ? 'Atualizar' : 'Salvar'}
        </Button>
        <Button sx={{ ml: 1 }} onClick={() => setEditing({})}>
          Criar Nova Tag
        </Button>
      </Box>
      <List>
        {tags.map((tag) => (
          <ListItem
            key={tag.id}
            secondaryAction={
              <>
                <Button size="small" onClick={() => setEditing(tag)}>
                  Editar
                </Button>
                <Button
                  size="small"
                  color="error"
                  onClick={async () => {
                    await deleteTag(tag.id);
                    load();
                  }}
                >
                  Excluir
                </Button>
              </>
            }
          >
            <ListItemText primary={tag.nome || tag.nome_pt} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default TagsPage;

